define(function (require) {
    "use strict";

    var Logger = require("logger");
    var Marionette = require("marionette");
    var Media = require("media");
    var GridViewFilterLayout = require("ui.plugins/gridView/filter/views/GridViewFilterLayout");
    var _ = require("underscore");
    var $ = require("jquery");

    //============================================================
    // Marionette.GraphQLGridView
    //============================================================

    var FILTER_ICON_CLASS = "filter";
    var FILTER_ACTIVE_CLASS = "filtered";
    var FILTER_OPEN_CLASS = "open-filter";
    var ORDER_ICON_CLASS = "order";
    var ORDER_ACTIVE_CLASS = "sorted";

    Marionette.GraphQLGridView = Marionette.CompositeView.extend({

        constructor: function (options) {

            Marionette.CompositeView.prototype.constructor.call(this, options);

            this.graphQLLogger = Logger.getLogger("GraphQLGridView");
            this.permutation = options.permutation || Marionette.GraphQLGridView.PERMUTATION.A;
            this.filters = options.filters || [];
            this.openFilterName = null;
            this.filterVent = Media.vent();
        },

        appendHtml: function (collectionView, itemView, index) {
            if (index % 2 === 0) {
                itemView.$el.addClass("odd");
            }
            else {
                itemView.$el.addClass("even");
            }
            //append html is using buffering we dont really want to override it .
            // but if we do we need to use the same buffering technique
            Marionette.CompositeView.prototype.appendHtml.call(this, collectionView, itemView, index);
        },

        //---------------------------------------------------
        // render
        //---------------------------------------------------

        render: function () {

            Marionette.CompositeView.prototype.render.call(this);

            var table = this.$el.find("table");

            if (table){
                this.setTheme(table);
                this.setOrderClick(table);
                this.setFilteringClick(table);
                this.setActiveOrder();
                this.setActiveFilters();

                this.listenTo(this.collection, "fetch:success fetch:error", this._onCollectionFetched);
            }
        },

        _onCollectionFetched: function() {
            // Tomer: This need to be in defer because it's triggered before the success callback so we don't have the data on the collection if we don't defer it (as the data on the collection arrived in the success callback)
            _.defer(_.bind(function() {
                this.setActiveOrder();
                this.setActiveFilters();
            }, this));
        },

        setTheme: function (table) {
            table.addClass("table-perm" + this.permutation);
        },

        setOrderClick: function (table) {
            var viewContext = this;

            table.on("click", "th .order, th .content", function(){
                var $th = $(this).parents("th");
                var orderBy = $th.attr("data-comparator");
                if(!_.isEmpty(orderBy)){
                    var orderIcon = $th.find("." + ORDER_ICON_CLASS);
                    var orderDirection = orderIcon.hasClass(viewContext.collection.ORDER_DIRECTION.ASC) ? viewContext.collection.ORDER_DIRECTION.DESC : viewContext.collection.ORDER_DIRECTION.ASC;
                    viewContext.collection.setOrderBy(orderBy, {fetchOnChange:false});
                    viewContext.collection.setOrderDirection(orderDirection);
                }
            });
        },

        setFilteringClick: function (table) {
            var viewContext = this;

            table.on("click", "th .filter", function(){
                var $th = $(this).parents("th");
                var filterIcon = $th.find("." + FILTER_ICON_CLASS);

                var filterName = $th.attr("data-filter");
                var needToCloseFilter = !_.isNull(viewContext.openFilterName);
                var needToOpenFilter = _.isNull(viewContext.openFilterName) || viewContext.openFilterName !== filterName;

                // close open filter when filter icon clicked (outside clicks are handled inside the ridViewFilterLayout view):
                if (needToCloseFilter) {
                    viewContext.filterVent.trigger("gridView:closeFilter");
                }

                if (needToOpenFilter) { //open the filter if an icon of a closed filter is clicked
                    var filters = _.where(viewContext.filters, {name: filterName});
                    if(filters.length > 0) { //continue to open the filter only if there are filter params defined for it
                        var filterObject = filters[0];
                        var filterView = new GridViewFilterLayout({
                            targetElement: filterIcon,
                            collection: viewContext.collection,
                            filterName: filterName,
                            filterType: filterObject.type,
                            filterData: filterObject.getFilterData(),
                            vent: viewContext.filterVent
                        });
                        filterView.render();
                        filterIcon.addClass(FILTER_OPEN_CLASS);
                        viewContext.openFilterName = filterName;

                        viewContext.listenTo(filterView, "close", function () {
                            viewContext.$el.find("." + FILTER_OPEN_CLASS).removeClass(FILTER_OPEN_CLASS);
                            viewContext.openFilterName = null;
                        }, this);
                    }
                    else {
                        viewContext.graphQLLogger.error("marionette.graphQLGridView:setFilteringClick error. no filter","marionette.graphQLGridView:setFilteringClick", filterName);
                    }
                }
            });
        },

        setActiveOrder: function() {
            this.$el.find("th[data-comparator]").each(_.bind(function(i, th) {
                var $th = $(th);
                var orderIcon = $th.find("." + ORDER_ICON_CLASS);

                $th.removeClass(ORDER_ACTIVE_CLASS);
                orderIcon.removeClass(this.collection.ORDER_DIRECTION.ASC +" "+ this.collection.ORDER_DIRECTION.DESC);
                var orderBy = $th.attr("data-comparator");
                if (!_.isEmpty(orderBy)) {
                    var orderByIndex = _.indexOf(this.collection.getOrderBy(), orderBy);
                    if (orderByIndex > -1) {
                        var orderDirection = this.collection.getOrderDirection()[orderByIndex];
                        $th.addClass(ORDER_ACTIVE_CLASS);
                        orderIcon.addClass(orderDirection);
                    }
                }
            }, this));
        },

        setActiveFilters: function() {
            this.$el.find("th[data-filter]").each(_.bind(function(i, th) {
                var $th = $(th);
                var filterIcon = $th.find("." + FILTER_ICON_CLASS);

                var filterName = $th.attr("data-filter");
                if (!_.isEmpty(filterName)) {
                    var filterValue = this.collection.getFilterValue(filterName);
                    var isFiltered = (!_.isEmpty(filterValue));
                    filterIcon.toggleClass(FILTER_ACTIVE_CLASS, isFiltered);
                }
            }, this));
        }
    });

    Marionette.GraphQLGridView.PERMUTATION = {
        A   :"A",
        B   :"B"
    };

    Marionette.GraphQLGridView.FILTERS = {};
    Marionette.GraphQLGridView.FILTERS.TYPES = GridViewFilterLayout.FILTER_TYPES;

    return  Marionette;
});
